import React from "react";

const PaychexLogoV2 = () => {
  return (
    <svg
      width="292"
      height="47"
      viewBox="0 0 292 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_184_71)">
        <path
          d="M20.475 12.825H25.11C28.035 12.825 31.05 13.41 31.05 16.785C31.05 19.71 29.205 21.78 23.715 21.78H18.63L20.475 12.825ZM0 45.765H13.5L16.29 32.355H25.47C37.125 32.355 44.685 24.66 44.685 15.705C44.685 5.94002 39.465 1.39502 31.275 1.39502H9.315L0 45.765Z"
          fill="#004B8D"
        />
        <path
          d="M61.335 16.65L62.955 29.925H54.45L61.335 16.65ZM32.13 45.765H46.08L49.455 39.465H63.9L64.62 45.765H78.03L71.28 1.39502H57.78L32.13 45.765Z"
          fill="#004B8D"
        />
        <path
          d="M83.7 29.475L74.16 1.39502H87.885L92.07 17.91L102.915 1.39502H118.98L97.335 29.34L93.96 45.765H80.325L83.7 29.475Z"
          fill="#004B8D"
        />
        <path
          d="M151.56 28.89C150.75 33.435 147.24 46.8 128.745 46.8C115.83 46.8 109.665 38.43 109.665 26.55C109.665 12.24 118.62 0.224976 133.785 0.224976C143.685 0.224976 152.55 4.54498 152.775 17.82H139.86C139.995 13.635 138.015 11.295 133.785 11.295C126.225 11.295 123.435 20.025 123.435 26.325C123.435 30.06 124.38 35.64 130.635 35.64C134.955 35.64 137.385 32.715 138.195 28.755L151.56 28.89Z"
          fill="#004B8D"
        />
        <path
          d="M159.48 1.39502H173.25L169.965 16.785H182.43L185.67 1.39502H199.44L190.125 45.765H176.49L180.09 28.17H167.625L163.935 45.765H150.3L159.48 1.39502Z"
          fill="#004B8D"
        />
        <path
          d="M203.04 1.39502H239.715L237.375 12.825H214.335L213.165 18.27H234.585L232.38 28.89H210.96L209.79 34.335H233.28L230.985 45.765H193.725L203.04 1.39502Z"
          fill="#004B8D"
        />
        <path
          d="M249.12 22.23L238.905 1.39502H253.8L258.12 12.915L266.94 1.39502H283.14L264.6 22.23L275.445 45.765H260.1L255.195 33.39L244.845 45.765H228.06L249.12 22.23Z"
          fill="#004B8D"
        />
        <path
          d="M284.895 3.375C284.895 1.755 286.065 0.45 287.685 0.45C289.215 0.45 290.475 1.71 290.475 3.375C290.475 5.04 289.305 6.3 287.685 6.3C286.155 6.3 284.895 4.995 284.895 3.375ZM284.31 3.375C284.31 5.355 285.84 6.75 287.685 6.75C289.53 6.75 291.06 5.355 291.06 3.375C291.06 1.53 289.53 0 287.685 0C285.84 0 284.31 1.53 284.31 3.375ZM286.38 5.355H286.965V3.735H287.55L288.585 5.49H289.305L288.135 3.735C288.72 3.735 289.17 3.375 289.17 2.7C289.17 1.89 288.72 1.53 287.775 1.53H286.38V5.355ZM286.965 1.98H287.775C288.225 1.98 288.585 2.115 288.585 2.565C288.585 3.15 288.135 3.285 287.55 3.285H286.965V1.98Z"
          fill="#004B8D"
        />
      </g>
      <defs>
        <clipPath id="clip0_184_71">
          <rect width="291.06" height="46.8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaychexLogoV2;
